<div class="chart-container" style="position: relative; height:80vh">
  <canvas baseChart *ngIf="pieChartLabels && pieChartData"
          [datasets]="pieChartData"
          [labels]="pieChartLabels"
          [options]="pieChartOptions"
          [legend]="showLegend"
          [type]="pieChartType"
          [plugins]="pieChartPlugins">
  </canvas>
</div>
